module.exports = __webpack_public_path__ + "img/ethereum.6cbd9d8f.svg";